// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-profile-view-data {
  display: block;
}

.fi-profile-view-data-label {
  color: var(--fi-color-dark);
  font-size: 0.8em;
}

.fi-profile-view-data-content {
  color: var(--fi-color-default);
}`, "",{"version":3,"sources":["webpack://./Source/app/components/profile-view/data/profile-view-data.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ","sourcesContent":["fi-profile-view-data {\r\n    display: block;\r\n}\r\n\r\n.fi-profile-view-data-label {\r\n    color: var(--fi-color-dark);\r\n    font-size: 0.8em;\r\n}\r\n\r\n.fi-profile-view-data-content {\r\n    color: var(--fi-color-default);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
